import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { Auth } from 'aws-amplify';
import { CognitoService } from '../../core/services/cognito.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../core/auth/services/auth.service';

@Component({
    selector: 'app-signup-profile',
    templateUrl: './sign-up-profile.component.html',
    styleUrls: ['./sign-up-profile.component.scss'],
})
export class SignUpProfileComponent implements OnInit {
    @Input() user: any;
    step = 'sign-up-profile';
    file?: any;
    previewUrl?: any;

    signUpProfileForm = new FormGroup({
        name: new FormControl('', { updateOn: 'blur' }),
        phoneNumber: new FormControl('', { updateOn: 'blur' }),
    });

    get nameCtrl(): FormControl {
        return this.signUpProfileForm.get('name') as FormControl;
    }

    get phoneNumberCtrl(): FormControl {
        return this.signUpProfileForm.get('phoneNumber') as FormControl;
    }

    constructor(
        private cognitoService: CognitoService,
        private http: HttpClient,
        private ngxService: NgxUiLoaderService,
        private _snackBar: MatSnackBar,
        private authService: AuthService
    ) {}

    ngOnInit() {
        this.signUpProfileForm.patchValue({
            name: this.user.name,
            phoneNumber: this.user.phoneNumber,
        });
    }

    async updateProfile() {
        if (this.signUpProfileForm.invalid) {
            this.signUpProfileForm.markAllAsTouched();
        } else {
            this.ngxService.start();
            let picture;
            if (this.file) {
                picture = await this.uploadFileToServer(this.file);
            }
            const request: any = {
                name: this.nameCtrl.value,
                phone_number: this.phoneNumberCtrl.value,
            };
            if (picture) {
                request.picture = picture;
            }
            this.cognitoService
                .updateAttrUser(request)
                .then(() => {
                    this.step = 'sign-up-verification-code';
                    this.ngxService.stop();
                    this.authService.currentSession().then((data: any) => {
                        const accessToken = data.accessToken.jwtToken;
                        const idToken = data.idToken.jwtToken;
                        this.authService.onAuthentication(accessToken, idToken);
                        this.authService.emitUpdateUser();
                    });
                })
                .catch(error => {
                    this._snackBar.open(error.message, 'x', {
                        horizontalPosition: 'right',
                        verticalPosition: 'top',
                        panelClass: ['notif-error'],
                        duration: 2000,
                    });
                    this.ngxService.stop();
                });
        }
    }

    uploadInputChange(fileInputEvent: any) {
        if (fileInputEvent.target.files.length > 0) {
            this.file = fileInputEvent.target.files[0];
            if (this.file) {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    this.previewUrl = e.target.result;
                };
                reader.readAsDataURL(this.file);
            }
        }
    }

    async uploadFileToServer(file: any): Promise<string> {
        const baseUrl = environment.api.endpoint;
        const formData = new FormData();
        const {
            signInUserSession: {
                accessToken: { jwtToken },
            },
        } = await Auth.currentAuthenticatedUser();

        const headers = { Authorization: `Bearer ${jwtToken}` };

        formData.append('file', file);

        const response = await this.http
            .post<{ path: string }>(`${baseUrl}/File/UploadImage`, formData, { headers })
            .toPromise();
        return response.path;
    }
}
